import React, { useState } from 'react'
import { Container, Main, Title, ExpandableContentItem, ExpandableItem } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { IAntibiotic } from '~/interfaces'
import { transformDate } from '~/utils'

export interface AntibioticItemProps {
  antibiotic: IAntibiotic
}

const AntibioticItem: React.FC<AntibioticItemProps> = ({ antibiotic }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const date = transformDate({ date: antibiotic.date })
  const hour = transformDate({ date: antibiotic.date, dateFormat: 'HH:mm:ss' })

  const toggleOpeningMainContent = () => {
    setIsOpen(!isOpen)
  }

  return (
    <Container>
      <Main data-testid="main" onClick={toggleOpeningMainContent} isOpen={isOpen}>
        <Title>
          {antibiotic.name}
          <br />
          <span>
            {date} | {hour}
          </span>
        </Title>
        <IconComponent name={isOpen ? 'chevronUp' : 'chevronDown'} />
      </Main>
      {isOpen && (
        <ExpandableContentItem>
          <ExpandableItem>{antibiotic.prescription}</ExpandableItem>
        </ExpandableContentItem>
      )}
    </Container>
  )
}

export { AntibioticItem }
